import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { RouteConfig } from '../../config/routerConfig';
import RouteRenderComponent from './RouteRenderComponent';
import Page403 from '../../pages/403';
import Page404 from '../../pages/404';
import { useSelector } from 'react-redux';
import { isDevelopment } from '../../utils/check';
import MgrType from '../../const/MgrType';
import UserType from '../../const/UserType';

interface RouteListProps {
  routeConfig: RouteConfig[];
}

function RouteList(props: RouteListProps) {
  // @ts-ignore
  const currentMenuList = useSelector((state) => state.user.currentMenuList);
  // @ts-ignore
  const wholeMenuList = useSelector((state) => state.user.wholeMenuList);
  // @ts-ignore
  const userType = useSelector((state) => state.user.type);
  // @ts-ignore
  const mgrType = useSelector((state) => state.user.mgrType);
  const { routeConfig } = props;
  const location = useLocation();

  function hasPermission(currentPath: string, permitUserType?: UserType | UserType[]) {
    if (isDevelopment() && mgrType === MgrType.SUPER_ADMIN) {
      return true;
    }

    const inMenu = wholeMenuList.includes(currentPath);
    const inCurrentMenu = currentMenuList.includes(currentPath);
    // 在全局菜单里, 但是不在本人菜单中
    if (inMenu && !inCurrentMenu) {
      return false;
    }

    // 默认可以访问
    if (permitUserType == null) {
      return true;
    }

    if (Array.isArray(permitUserType)) {
      return permitUserType.includes(userType);
    }
    return userType === permitUserType;
  }

  return (
    <Switch location={location}>
      {routeConfig.map((config) => {
        const { path, component, auth, exact = !!component, ...restProps } = config;

        return (
          // @ts-ignore
          <Route
            key={path}
            exact={exact}
            path={path}
            render={(RouteProps) => {
              if (!hasPermission(path, auth)) {
                return <Redirect to="/403" />;
              }
              return <RouteRenderComponent component={component} {...restProps} {...RouteProps} />;
            }}
            onLeave={window.scrollTo(0, 0)}
          />
        );
      })}
      <Route path="/403" component={Page403} />
      <Route component={Page404} />
    </Switch>
  );
}

RouteList.defaultProps = {
  routeConfig: [],
};

export default RouteList;
